import React from 'react';
import { useUserData } from '../../lib/redux/users/user-data-hook';
import { AlertCircle } from 'lucide-react';

interface AccessProps {
  children: React.ReactNode;
}

export const Access: React.FC<AccessProps> = ({ children }) => {
  const { user } = useUserData();

  const isDeactivated = user ? !user.team_is_active : false;

  if (!isDeactivated) {
    return <>{children}</>;
  }

  return (
    <div className="relative w-full h-full">
      <div className="w-full h-full">
        {children}
      </div>

      <div className="absolute inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-white/30 pointer-events-auto">
        <div className="bg-white/90 backdrop-blur-md rounded-2xl shadow-2xl p-8 max-w-md mx-4 border border-gray-200">
          <div className="flex flex-col items-center text-center space-y-4">
            <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
              <AlertCircle className="w-10 h-10 text-red-600" />
            </div>

            <h2 className="text-2xl font-bold text-gray-900">
              Account Deactivated
            </h2>

            <p className="text-gray-600 text-base">
              Your account has been deactivated. Please contact your administrator or support to reactivate your account.
            </p>

            <div className="pt-4">
              <div
                onClick={() => {
                  navigator.clipboard.writeText('support@trellus.ai');
                }}
                className="inline-flex items-center px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium rounded-lg transition-colors duration-200 cursor-pointer"
              >
                support@trellus.ai
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
